// src/components/manager/peopleColors.js
// Families with 3 shades each (brightened for calendar chips)
export const PEOPLE_FAMILIES = {
  teal: ['#59b6bb', '#4aa7ad', '#3e99a0'],
  amber: ['#c89b53', '#b88943', '#a87833'],
  magenta: ['#b669b5', '#a559a4', '#944a93'],
  pink: ['#F472B6', '#EC4899', '#DB2777'],
};

// Static mapping for known names; default neutral if not found
export const peopleColorMap = {
  Ivana: { family: 'teal', shade: 1 },
  Josipa: { family: 'teal', shade: 2 },
  Mirna: { family: 'teal', shade: 3 },
  Petar: { family: 'amber', shade: 1 },
  Petra: { family: 'amber', shade: 2 },
  Jana: { family: 'magenta', shade: 1 },
  Lea: { family: 'magenta', shade: 2 },
  Elena: { family: 'magenta', shade: 3 },
  Paola: { family: 'pink', shade: 1 },
  Tara: { family: 'pink', shade: 2 },
  Terezija: { family: 'pink', shade: 3 },
};

function normalizeKey(name) {
  return String(name || '').trim().toLowerCase();
}

function titleCaseWord(w) {
  const s = String(w || '').trim();
  if (!s) return '';
  return s[0].toUpperCase() + s.slice(1).toLowerCase();
}

export function getPersonColor(name) {
  const raw = String(name || '').trim();
  const direct = peopleColorMap[raw];
  const firstWord = raw.split(/\s+/)[0] || '';
  const meta = direct
    || peopleColorMap[firstWord]
    || peopleColorMap[titleCaseWord(firstWord)]
    || peopleColorMap[titleCaseWord(normalizeKey(firstWord))];
  if (!meta) return '#9CA3AF';
  const shades = PEOPLE_FAMILIES[meta.family] || PEOPLE_FAMILIES.teal;
  const idx = Math.max(0, Math.min(shades.length - 1, (meta.shade || 1) - 1));
  return shades[idx];
}
